import serverVars from 'server-vars';
import { trackAbTestEvent } from 'dibs-tracking';
import { getAbTestTrackingData } from 'dibs-buyer-layout/exports/clientABTestHelpers';
import { PAGE_TYPE, BROWSE_TYPES } from 'dibs-constants/exports/pageTypes';
import { isAbTestVariant, isAbTestControl } from '../../../src/utils/abTest/clientABTestHelpers';
import { AB_TEST_MW_APP_BANNER_KEY, APP_BANNER_STORAGE_KEY } from './constants';
import {
    GDPR_KEY_AGREED,
    GDPR_KEY_NOT_APPLICABLE,
} from '../../components/CookieNotification/constants';

export const isAppBannerAbTest =
    isAbTestVariant(document.cookie, AB_TEST_MW_APP_BANNER_KEY) ||
    isAbTestControl(document.cookie, AB_TEST_MW_APP_BANNER_KEY);

export const trackAppBannerAbTest = (): void => {
    trackAbTestEvent(
        getAbTestTrackingData(document.cookie, AB_TEST_MW_APP_BANNER_KEY),
        'session_landing_page'
    );
};

export const shouldPromptAppBanner = (): boolean => {
    const isLocalSet = !!localStorage.getItem(GDPR_KEY_AGREED);
    const isSessionSet = !!sessionStorage.getItem(GDPR_KEY_NOT_APPLICABLE);
    const hasNoNotifParam =
        new URLSearchParams(document.location.search).get('no-notif') === 'true';
    const hasClosedBanner = !!sessionStorage.getItem(APP_BANNER_STORAGE_KEY);
    const allowedPageTypes = [PAGE_TYPE.HOME, PAGE_TYPE.PDP, ...BROWSE_TYPES];
    const pageType = serverVars.get('settings.pageType');
    const isAllowedPageType = allowedPageTypes.includes(pageType);

    if (
        (!isLocalSet && !isSessionSet) ||
        !isAbTestVariant(document.cookie, AB_TEST_MW_APP_BANNER_KEY)
    ) {
        return false;
    }

    return isAllowedPageType && !hasNoNotifParam && !hasClosedBanner;
};
